import React, { useState } from 'react';
import { hhmm, localParts, weekdayDate } from '../lib/time';
import { PIN_COLORS } from './Board';

/** Every pin with its time in each city, plus a copy-as-text button for invites. */
export default function PinList({ pins, cities, onEdit, onRemove, onJump }) {
  const [copied, setCopied] = useState(null);
  if (!pins.length || !cities.length) return null;
  const home = cities[0];

  const asText = (p) =>
    `${p.label}\n` +
    cities.map((c) => `${c.name}: ${hhmm(localParts(c.timezone, p.t))} ${weekdayDate(c.timezone, p.t)}`).join('\n');

  const copy = async (p) => {
    try {
      await navigator.clipboard.writeText(asText(p));
      setCopied(p.id);
      setTimeout(() => setCopied(null), 1500);
    } catch (e) { /* clipboard blocked */ }
  };

  return (
    <section className="pins">
      <h2>Pinned times</h2>
      <ul>
        {pins.map((p) => (
          <li key={p.id} style={{ '--pin': PIN_COLORS[p.color] || PIN_COLORS.blue }}>
            <button className="pin-name" onClick={() => onJump(localParts(home.timezone, p.t).date)} title="Show this day">
              {p.label}
            </button>
            <div className="pin-times">
              {cities.map((c) => (
                <span key={c.name}>
                  <b>{hhmm(localParts(c.timezone, p.t))}</b> {c.name}
                </span>
              ))}
            </div>
            <div className="pin-actions">
              <button onClick={() => copy(p)}>{copied === p.id ? 'Copied' : 'Copy'}</button>
              <button onClick={() => onEdit(p)}>Edit</button>
              <button onClick={() => onRemove(p.id)} aria-label={`Delete ${p.label}`}>Delete</button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
